import { Component } from '@angular/core';

@Component({
  selector: 'allas-guia-afiliarse',
  imports: [],
  template: `
    <section class="bg-[#df030b] grid grid-cols-12 text-white p-4 xl:p-8">
      <div
        class="col-span-12 xl:col-span-6 flex flex-col xl:gap-1 justify-center items-center"
      >
        <span class="text-3xl xl:text-3xl font-medium"> COMO AFILIARSE </span>
        <span class="text-5xl xl:text-6xl font-bold fs-condensed">
          AL PROGRAMA
        </span>
        <span class="text-sm xl:text-xl font-light">
          El proceso es muy sencillo. Sigue estos pasos <br />
          y comienza a disfrutar de todos los beneficios
        </span>
      </div>
      <div class="col-span-12 xl:col-span-6 flex flex-col gap-6 mt-6 xl:mt-0">
        <div class="flex gap-6">
          <span
            class="w-8 min-w-8 xl:w-12 xl:min-w-12 flex items-center justify-center"
          >
            <img
              src="/logos/to-delete/logo-miniatura-white.webp"
              alt="Logo en Miniatura de Allas"
              class="h-full w-full object-contain"
            />
          </span>
          <span class="flex flex-col">
            <span class="text-[10px] xl:text-lg font-light opacity-90">
              Descarga la app o visítanos: Visita una de nuestras tiendas
              físicas o descarga nuestra app desde tu móvil.
            </span>
            <div class="w-full h-[1px] bg-white mt-2"></div>
          </span>
        </div>
        <div class="flex gap-6">
          <span
            class="w-8 min-w-8 xl:w-12 xl:min-w-12 flex items-center justify-center"
          >
            <img
              src="logos/to-delete/lista.webp"
              alt="Logo en Miniatura de Allas"
              class="h-full w-full object-contain"
            />
          </span>
          <span class="flex flex-col">
            <span class="text-[10px] xl:text-lg font-light opacity-90">
              Completa tu registro: En tu App movil busca la opción de
              Afiliación y llena tus datos básicos de identificación, contacto y
              luego confirma tu información.
            </span>
            <div class="w-full h-[1px] bg-white mt-2"></div>
          </span>
        </div>
        <div class="flex gap-6">
          <span
            class="w-8 min-w-8 xl:w-12 xl:min-w-12 flex items-center justify-center"
          >
            <img
              src="logos/to-delete/qr.webp"
              alt="Logo en Miniatura de Allas"
              class="h-full w-full object-contain"
            />
          </span>
          <span class="flex flex-col">
            <span class="text-[10px] xl:text-lg font-light opacity-90">
              ¡Comienza a acumular puntos!: Desde tu primera compra muestra el
              código QR que obtiendes desde tu App Movil a tu asesor al momento
              de facturar y estarás acumulando puntos.
            </span>
          </span>
        </div>
      </div>
    </section>
  `,
})
export class GuiaAfiliarse {}
